import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { EntitiyType } from "src/types/apps";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";
import { ChangeMantenanceBodyNetType } from "./NetTypes";

async function changeMantenanceEntityRequest({
	entityId,
	maintenance
}: ChangeMantenanceBodyNetType) {
	return await apiClient
		.put(API.COMMAND.ADMIN.CHANGE_ENTITY_MAINTENANCE(entityId, maintenance))
		.then((res) => res.data);
}

export function useChangeMantenanceEntity() {
	return useMutation<any, AxiosError, ChangeMantenanceBodyNetType>({
		mutationFn: (payload: ChangeMantenanceBodyNetType) => changeMantenanceEntityRequest(payload)
	});
}

async function updateEntityRequest({ marketer, marketerCif, id }: EntitiyType) {
	return await apiClient
		.put(API.COMMAND.ADMIN.UPDATE_ENTITY, { marketer, marketerCif, id })
		.then((res) => res.data);
}

export function useUpdateEntityRequest() {
	return useMutation<any, AxiosError, EntitiyType>({
		mutationFn: (payload: EntitiyType) => updateEntityRequest(payload)
	});
}
